import PropTypes from "prop-types";
import Modal from "../../../../../parts/modal";
import { normalizeRecipeDetails } from "../utils/recipe-details";
import { RecipeDetailView } from "./RecipeDetailView";

const TO_CLEAR = ["recipeType", "recipeId"];
const CLOSE_HREF = `/actions/refresh?modal=&${TO_CLEAR.join("=&")}=`;

export const RecipeDetailModal = ({ locals }) => {
  const recipe = normalizeRecipeDetails(locals.recipeDetails);

  return (
    <Modal
      className="recipe-detail-modal"
      width="52rem"
      canClose={false}
      toClear={TO_CLEAR}
    >
      <RecipeDetailView
        recipe={recipe}
        status={recipe ? "ready" : "notFound"}
        closeHref={CLOSE_HREF}
      />
    </Modal>
  );
};

RecipeDetailModal.propTypes = {
  locals: PropTypes.shape({
    recipeDetails: PropTypes.object,
  }).isRequired,
};
